"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
var LETTERS_LAYOUT = [["A", "Z", "E", "R", "T", "Y", "U", "I", "O", "P"], ["Q", "S", "D", "F", "G", "H", "J", "K", "L", "M"], ["Shift", "W", "X", "C", "V", "B", "N", "←"], ["123", ".", "@", "Space", "Return"]];
var NUMBERS_LAYOUT = [["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], ["-", "_", "!", "?", ":", ";", "/", "&", "%"], ["Shift", "←"], ["ABC", "Space", "Return"]];
function AzertyKeyboard(_ref) {
  var input = _ref.input,
    setInput = _ref.setInput,
    project = _ref.project,
    setVisible = _ref.setVisible,
    anchorRef = _ref.anchorRef;
  var keyboardRef = (0, _react.useRef)(null);
  var dragStartRef = (0, _react.useRef)({
    x: 0,
    y: 0
  });
  var _ref2 = (0, _react.useState)({
      x: 0,
      y: 0
    }),
    _ref3 = _slicedToArray(_ref2, 2),
    position = _ref3[0],
    setPosition = _ref3[1];
  var _ref4 = (0, _react.useState)(false),
    _ref5 = _slicedToArray(_ref4, 2),
    dragging = _ref5[0],
    setDragging = _ref5[1];
  var _ref6 = (0, _react.useState)("letters"),
    _ref7 = _slicedToArray(_ref6, 2),
    layout = _ref7[0],
    setLayout = _ref7[1];
  var _ref8 = (0, _react.useState)(1.0),
    _ref9 = _slicedToArray(_ref8, 2),
    scale = _ref9[0],
    setScale = _ref9[1];
  var _ref0 = (0, _react.useState)(false),
    _ref1 = _slicedToArray(_ref0, 2),
    isReady = _ref1[0],
    setIsReady = _ref1[1];
  var scaleForWidth = function scaleForWidth(w) {
    return w >= 2500 ? 1.1 : w >= 1800 ? 1.0 : w >= 1200 ? 0.9 : 0.75;
  };

  // Center the keyboard horizontally and clamp it inside the viewport so the (scaled) keyboard never
  // runs off the right/left edge on a larger screen. Position the top just under the anchored card.
  // Recomputed on resize too — not only the scale — so a wider keyboard stays centred and on-screen.
  var reposition = function reposition(newScale) {
    if (!(anchorRef !== null && anchorRef !== void 0 && anchorRef.current) || !keyboardRef.current) return;
    var rect = anchorRef.current.getBoundingClientRect();
    var keyboardWidth = keyboardRef.current.offsetWidth * newScale;
    var margin = 8;
    var maxX = Math.max(margin, window.innerWidth - keyboardWidth - margin);
    var centeredX = (window.innerWidth - keyboardWidth) / 2;
    setPosition({
      x: Math.min(Math.max(margin, centeredX), maxX),
      y: rect.bottom + 10
    });
  };

  /* 📍 Gestion du resize (scale dynamique + recentrage) */
  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      var newScale = scaleForWidth(window.innerWidth);
      setScale(newScale);
      reposition(newScale);
    };
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);

  /* 📍 Calcul scale + position AVANT affichage pour éviter le flicker */
  (0, _react.useLayoutEffect)(function () {
    if (!(anchorRef !== null && anchorRef !== void 0 && anchorRef.current) || !keyboardRef.current) return;

    // Calcul scale initial avant position
    var newScale = scaleForWidth(window.innerWidth);
    setScale(newScale);
    reposition(newScale);
    setIsReady(true);
  }, [anchorRef]);

  /* 🖱 Drag */
  var startDrag = function startDrag(clientX, clientY) {
    setDragging(true);
    dragStartRef.current = {
      x: clientX - position.x,
      y: clientY - position.y
    };
  };
  var moveDrag = function moveDrag(clientX, clientY) {
    if (!dragging) return;
    setPosition({
      x: clientX - dragStartRef.current.x,
      y: clientY - dragStartRef.current.y
    });
  };
  var stopDrag = function stopDrag() {
    return setDragging(false);
  };

  /* ⌨️ Touches */
  var handleKeyClick = function handleKeyClick(key) {
    if (key === "←") setInput(function (v) {
      return v.slice(0, -1);
    });else if (key === "Space") setInput(function (v) {
      return v + " ";
    });else if (key === "Return") setInput(function (v) {
      return v + "\n";
    });else if (key === "123") setLayout("numbers");else if (key === "ABC") setLayout("letters");else if (key === "Shift") return;else setInput(function (v) {
      return v + key;
    });
  };
  var currentLayout = layout === "letters" ? LETTERS_LAYOUT : NUMBERS_LAYOUT;
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: keyboardRef,
    style: {
      // `fixed` (not `absolute`) so top/left are viewport coordinates — matching the
      // window.innerWidth / getBoundingClientRect() math in reposition(). With `absolute` the
      // keyboard anchors to its nearest positioned ancestor (the device-framed preview box, which
      // is narrower/offset from the window), which pushed it off the right edge.
      position: "fixed",
      top: position.y,
      left: position.x,
      zIndex: 14000,
      padding: "0.6em",
      background: "rgba(255,255,255,0.92)",
      borderRadius: "1em",
      boxShadow: "0 0.6em 1.2em rgba(0,0,0,0.3)",
      backdropFilter: "blur(6px)",
      transform: "scale(".concat(scale, ")"),
      transformOrigin: "top left",
      width: "fit-content",
      visibility: isReady ? "visible" : "hidden"
    },
    onMouseMove: function onMouseMove(e) {
      return dragging && moveDrag(e.clientX, e.clientY);
    },
    onMouseUp: stopDrag,
    onMouseLeave: stopDrag,
    onTouchMove: function onTouchMove(e) {
      return dragging && moveDrag(e.touches[0].clientX, e.touches[0].clientY);
    },
    onTouchEnd: stopDrag
  }, /*#__PURE__*/_react.default.createElement("div", {
    onMouseDown: function onMouseDown(e) {
      return startDrag(e.clientX, e.clientY);
    },
    onTouchStart: function onTouchStart(e) {
      return startDrag(e.touches[0].clientX, e.touches[0].clientY);
    },
    style: {
      position: "absolute",
      top: -35,
      left: 0,
      width: "2.2em",
      height: "2.2em",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.95)",
      boxShadow: "0 0.3em 0.6em rgba(0,0,0,0.35)",
      cursor: dragging ? "grabbing" : "grab",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.3em",
      userSelect: "none"
    }
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "50",
    y1: "50",
    x2: "50",
    y2: "15",
    stroke: "black",
    strokeWidth: "4"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "50,10 45,20 55,20",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "50",
    y1: "50",
    x2: "50",
    y2: "85",
    stroke: "black",
    strokeWidth: "4"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "50,90 45,80 55,80",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "50",
    y1: "50",
    x2: "15",
    y2: "50",
    stroke: "black",
    strokeWidth: "4"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "10,50 20,45 20,55",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "50",
    y1: "50",
    x2: "85",
    y2: "50",
    stroke: "black",
    strokeWidth: "4"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "90,50 80,45 80,55",
    fill: "black"
  }))), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return setVisible(false);
    },
    style: {
      position: "absolute",
      top: -35,
      left: "95%",
      width: "2.2em",
      height: "2.2em",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.95)",
      boxShadow: "0 0.3em 0.6em rgba(0,0,0,0.35)",
      fontSize: "1.3em",
      cursor: "pointer"
    }
  }, "\u2715"), currentLayout.map(function (row, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: i,
      style: {
        display: "flex",
        gap: "0.3em",
        marginBottom: "0.3em"
      }
    }, row.map(function (key) {
      var minWidth = "3em";
      if (["Shift", "Return", "←"].includes(key)) minWidth = "6em";
      if (key === "Space") minWidth = "15em";
      return /*#__PURE__*/_react.default.createElement("button", {
        key: key,
        onClick: function onClick() {
          return handleKeyClick(key);
        },
        style: {
          minWidth: minWidth,
          padding: "1em",
          fontSize: "1.2em",
          borderRadius: "0.4em",
          background: "#0000004D",
          color: "#fff",
          border: "2px solid white",
          fontWeight: "bold",
          fontFamily: (project === null || project === void 0 ? void 0 : project.default_button_font) || "Arial"
        }
      }, key);
    }));
  }));
}
var _default = exports.default = AzertyKeyboard;